"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var launch = function (host, listing) {
    host.load({ path: "/ozone/listings/" + listing.id + "/launch", params: { id: listing.id, title: listing.title }, replace: true });
    return Promise.resolve();
};
exports.launch = launch;
